import './StageList.css';

function getStatusClass(status) {
  if (status === 'COMPLETE') return 'cj-slist__item--complete';
  if (status === 'IN_PROGRESS') return 'cj-slist__item--progress';
  if (status === 'PENDING_REVIEW') return 'cj-slist__item--review';
  return 'cj-slist__item--not-started';
}

function getStatusIcon(status) {
  if (status === 'COMPLETE') return '✓';
  if (status === 'IN_PROGRESS') return '●';
  if (status === 'PENDING_REVIEW') return '⏳';
  return '○';
}

export default function StageList({ stageDetails, selectedStageUid, onSelectStage }) {
  if (!stageDetails || stageDetails.length === 0) {
    return <div className="cj-slist__empty">No stages in this pipeline.</div>;
  }

  return (
    <div className="cj-slist">
      {stageDetails.map(stage => {
        const checklist = stage.checklist || [];
        const doneCount = checklist.filter(i => i.status === 'DONE').length;
        const totalCount = checklist.length;
        const percent = stage.stagePercent || 0;
        const isSelected = selectedStageUid === stage.stageUid;

        return (
          <button
            key={stage.stageUid}
            className={`cj-slist__item ${getStatusClass(stage.status)} ${isSelected ? 'cj-slist__item--selected' : ''}`}
            onClick={() => onSelectStage(stage.stageUid)}
          >
            <div className="cj-slist__top">
              <span className="cj-slist__status-dot">{getStatusIcon(stage.status)}</span>
              <span className="cj-slist__icon">{stage.stageIcon}</span>
              <span className="cj-slist__name">{stage.stageName}</span>
            </div>
            <div className="cj-slist__bar-row">
              <div className="cj-slist__bar">
                <div className="cj-slist__bar-fill" style={{ width: `${percent}%` }} />
              </div>
              <span className="cj-slist__count">{doneCount}/{totalCount}</span>
            </div>
          </button>
        );
      })}
    </div>
  );
}
